<script setup>
import { defineProps } from 'vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: 'mdi-file-document-outline'
  }
})
</script>


<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex align-center my-2">
        <v-icon size="40" class="mr-4" color="primary">{{ icon }}</v-icon>
        <div>
          <h1>{{ title }}</h1>
        </div>
      </div>
    </v-col>
  </v-row>
</template>


<style scoped>
/* Add any custom styles if needed */
</style>
